// GlobalCardByDistrict.tsx
import { Link } from "@remix-run/react";
import { GlobalRating } from "./GlobalRating";
import GlobalContactWhatsappFloating from "./GlobalContactWhatsappFloating";
import { InterfaceJasaByDistrict } from "~/types/GlobalInterfaces";
import { SITE_URL } from "~/assets/profile/profile";
interface GlobalCardByDistrictProps {
  data: InterfaceJasaByDistrict[];
  currentPage: string;
  serviceName: string;
  basePath: string;
}

export default function GlobalCardByDistrict({
  data,
  currentPage,
  serviceName,
  basePath,
}: GlobalCardByDistrictProps) {
  return (
    <ul className="grid gap-[1rem] grid-cols-1 lg:grid-cols-3">
      {data.map((item) => (
        <li
          key={item.id}
          className="bg-slate-200 flex flex-col p-4 rounded shadow-lg gap-2"
        >
          <h2 className="text-xl font-semibold pt-[0.5rem]">{item.inaTitle}</h2>

          <div className="flex flex-row lg:flex-col gap-2">
            <p className="bg-black text-sm font-semibold px-2 w-fit text-white py-1 rounded-sm shadow-lg">
              {item.district}
            </p>
            <p className="bg-black text-sm font-semibold px-2 w-fit text-white py-1 rounded-sm shadow-lg">
              {serviceName}
            </p>
          </div>

          <div className="flex flex-row gap-1">
            <p className="font-semibold">Konsultasi Gratis :</p>
            <p>YA</p>
          </div>

          {/* <GlobalRating rating={item.rating} /> */}
          <Link
            to={`${SITE_URL}${basePath}/${item.slug}`}
            className="typo-theme-primary hover:underline font-semibold"
          >
            <p>
              Lihat layanan {serviceName.toLowerCase()} di {item.district}
            </p>
          </Link>

          <GlobalContactWhatsappFloating
            currentPage={currentPage}
            buttonText={`Konsultasi Tim ${item.district}`}
          />
        </li>
      ))}
    </ul>
  );
}
